module.exports = __webpack_public_path__ + "static/hd-cb900f0dc98e02cdede7f2f5732d7798.png";